/**
 * Login modal
 */
import { WebRoute } from 'config/fe-routes';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { openLoginModal, setLoginModalStoreData } from 'store/actions/login.actions';
import { UserType } from 'types/user.types';

import Login from '../Login/Login';
import LoginTerms from '../Login/LoginTerms';
import LoginBanner from '../LoginBanner/LoginBanner';
import LoginPromocodeReferral from '../LoginPromocodeReferral/LoginPromocodeReferral';
import Modal from '../Modal/Modal';

type Props = {
  user: UserType;
  isLoginModalOpen: boolean;
  referralCode: string;
  loginRedirect?: WebRoute;
  storeData?: any;
};

const mapStateToProps = ({ userData, loginData }) => ({
  user: userData && userData.user,
  isLoginModalOpen: loginData?.isLoginModalOpen,
  referralCode: loginData.referralCode,
  loginRedirect: loginData?.redirect,
  storeData: loginData?.storeData,
});

const LoginModal = (props: Props) => {
  const { user, isLoginModalOpen, referralCode, loginRedirect, storeData } = props;

  // If user logged in, close modal
  useEffect(() => {
    if (user?.isLoggedIn) {
      openLoginModal(false);
    }
  }, [user]);

  if (user?.isLoggedIn) {
    return null;
  }

  const loginModalCloseHandler = () => {
    setLoginModalStoreData(null);
    openLoginModal(false);
  };

  return (
    <Modal
      open={isLoginModalOpen}
      onClose={loginModalCloseHandler}
      className="login-modal"
      contentClassName="login-modal-content"
      outsideContentChildren={
        <>
          <LoginTerms type="component" />
          <LoginBanner className="login-modal-loginbanner" />
        </>
      }
    >
      {referralCode && <LoginPromocodeReferral referralCode={referralCode} />}
      <Login type="component" loginRedirect={loginRedirect} excludeTerms={true} storeData={storeData} className="login-component" />
    </Modal>
  );
};

export default connect(mapStateToProps)(LoginModal);
